/*
 * API-3528: 2nd page for 2-steps promotions.
 *    On open, shows the page:
 *      - header with store details & CTAs,
 *      - iframe to display the availability's 2nd step url.
 */

class Awe2StepPage extends HTMLElement {

  constructor() {
    super()

    this.avail = null
    this.attachShadow({ mode: 'open' })

    const styleNd = document.createElement('style')

    styleNd.textContent = ``


    const ctnr = document.createElement('div')

    ctnr.id = 'ctnr'
    ctnr.innerHTML = `
      <div id="header">
        <button id="back" aria-label="${i18n.get('AWE-2STEP-PAGE.BACK')}"><span></span></button>
        <div class="title" id="title">
          <img class="brick-icon" src="../assets/3f9005c/img/brick.png">
          <span id="name">
            <span id="retailer"></span>
            <span id="store"></span>
            <span id="dist"></span>
          </span>
        </div>
      </div>
      <iframe id="form-ifr" allow="clipboard-write *;"></iframe>
      <awe-loader delay="100" id="loader-form"></awe-loader>
    `

    this.shadowRoot.append(styleNd, ctnr)

    const backNd = this.shadowRoot.getElementById('back')

    backNd.addEventListener('click', () => {
      this.classList.remove('open')
      this.shadowRoot.getElementById('form-ifr').src = ''
    })

    const ifr = this.shadowRoot.getElementById('form-ifr')

    ifr.addEventListener('load', () => {
      this.dispatchEvent(new CustomEvent('loader-end', { bubbles: true, detail: { target: 'loader-form' } }))
    })

    // add transition rule after a delay
    setTimeout(() => {
      const style2 = document.createElement('style')

      style2.textContent = ':host{transition:transform .2s,opacity .2s}'
      this.shadowRoot.append(style2)
    }, 400)
  }

  // edits or creates CTA node if needed, or removes it if not needed.
  renderLink(id, hasData, html = {}, redirectMode, previousSibling ) {
    let nd = this.shadowRoot.getElementById(id)
    let inDoc = true

    if (hasData) {
      if (nd) {
        nd.href = html.href
      }
      else {
        // insert node
        nd = document.createElement('a')
        nd.id = id
        nd.classList.add(...html.classes)
        nd.href = html.href
        if (html.target)
          nd.target = html.target
        nd.setAttribute('aria-label', i18n.get(html.labelKey))
        nd.innerHTML = html.innerHTML

        previousSibling.insertAdjacentElement('afterend', nd)
        nd.addEventListener('click', e => {
          player.redirect(e, this.avail, redirectMode)
        })
      }
    }
    else if (nd) {
      nd.remove()
      inDoc = false
    }

    return inDoc ? nd : null
  }

  // make page visible and render its details
  open(avail) {
    if (!avail) return

    this.avail = avail
    const title = this.shadowRoot.getElementById('title')

    let url = Mapping._replaceMacros(avail.voucher.secondStepUrl, {
      PAGEID: player.data.pageId,
      IID: player.data.iid,
      RFR: player.baseTrk.rfr,
      RFR2: player.baseTrk.rfr2,
      LEADID: avail.leadid,
    }).replace('{v}', Date.now())

    player.resetLeadid(avail)

    if (avail.voucher.secondStepType === 'FORM') {
      url += '&lang=' + player.data.locale

      // give form the raw url, with the {SWN-LEADID} placeholder.
      if (avail.rawClkUrl) {
        url += `&outbound_click=${encodeURIComponent(avail.rawClkUrl)}`
      }
    }

    this.shadowRoot.getElementById('form-ifr').src = url
    this.shadowRoot.getElementById('retailer').textContent = avail.retailer.name

    const storeName = avail.store.name.toLowerCase().replace(avail.retailer.name.toLowerCase(), '')

    this.shadowRoot.getElementById('store').textContent = storeName

    let dist = ''

    if (avail.store.brick || avail.store.drive || avail.store.collect)
      dist = i18n.formatDistance(avail.store.distance, true)
    this.shadowRoot.getElementById('dist').textContent = dist

    this.classList.add('open')

    // render CTA links for contact and locate buttons.
    const contact = player.data.remoteConf.show_contact

    const whatsappNd = this.renderLink('contact-whatsapp', !!(avail.store.whatsapp && contact === 'whatsapp'), {
      href: `https://api.whatsapp.com/send?phone=${avail.store.whatsapp}&text=${player.data.remoteConf.whatsapp_message}`,
      classes: ['contact', 'whatsapp', 'btn'],
      labelKey: 'AWE-2STEP-PAGE.WHATSAPP',
      innerHTML: '<img src="../assets/3f9005c/img/whatsapp.png" width="25px">',
    }, 'whatsapp', title)

    const appointmentNd = this.renderLink('contact-appointment', !!(avail.store.appointmentUrl && contact === 'appointment'), {
      href: avail.store.appointmentUrl,
      classes: ['contact', 'appointment', 'btn'],
      labelKey: 'AWE-2STEP-PAGE.APPOINTMENT',
      innerHTML: '<svg width="30px" height="30px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><path d="M 6 3 C 6 3 5 2.99997 5 4 L 3 4 L 3 7 L 3 18 L 3 19 L 13 19 L 13 18 L 4 18 L 4 7 L 18 7 L 18 13 L 19 13 L 19 7 L 19 4 L 17 4 C 17 2.99997 16 3 16 3 L 13 3 C 13 3 12 2.99997 12 4 L 10 4 C 10 2.99997 9 3 9 3 L 6 3 z M 6 4 L 9 4 L 9 5 L 6 5 L 6 4 z M 13 4 L 16 4 L 16 5 L 13 5 L 13 4 z M 6 8 L 6 10 L 8 10 L 8 8 L 6 8 z M 10 8 L 10 10 L 12 10 L 12 8 L 10 8 z M 14 8 L 14 10 L 16 10 L 16 8 L 14 8 z M 6 11 L 6 13 L 8 13 L 8 11 L 6 11 z M 10 11 L 10 13 L 12 13 L 12 11 L 10 11 z M 14 11 L 14 13 L 16 13 L 16 11 L 14 11 z M 16 14 L 16 16 L 14 16 L 14 17 L 16 17 L 16 19 L 17 19 L 17 17 L 19 17 L 19 16 L 17 16 L 17 14 L 16 14 z "></path></svg>',
    }, 'appointment', title)

    const renderPhone = avail.store.phone && (contact === 'phone' || contact === 'whatsapp' && !avail.store.whatsapp || contact === 'appointment' && !avail.store.appointmentUrl)
    const phoneNd = this.renderLink('contact-phone', !!renderPhone, {
      href: 'tel:' + avail.store.phone,
      target: '_top',
      classes: ['contact', 'phone', 'btn'],
      labelKey: 'AWE-2STEP-PAGE.PHONE',
      innerHTML: '<svg width="22px" height="22px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 122.27"><g><path d="M33.84,50.25c4.13,7.45,8.89,14.6,15.07,21.12c6.2,6.56,13.91,12.53,23.89,17.63c0.74,0.36,1.44,0.36,2.07,0.11 c0.95-0.36,1.92-1.15,2.87-2.1c0.74-0.74,1.66-1.92,2.62-3.21c3.84-5.05,8.59-11.32,15.3-8.18c0.15,0.07,0.26,0.15,0.41,0.21 l22.38,12.87c0.07,0.04,0.15,0.11,0.21,0.15c2.95,2.03,4.17,5.16,4.2,8.71c0,3.61-1.33,7.67-3.28,11.1 c-2.58,4.53-6.38,7.53-10.76,9.51c-4.17,1.92-8.81,2.95-13.27,3.61c-7,1.03-13.56,0.37-20.27-1.69 c-6.56-2.03-13.17-5.38-20.39-9.84l-0.53-0.34c-3.31-2.07-6.89-4.28-10.4-6.89C31.12,93.32,18.03,79.31,9.5,63.89 C2.35,50.95-1.55,36.98,0.58,23.67c1.18-7.3,4.31-13.94,9.77-18.32c4.76-3.84,11.17-5.94,19.47-5.2c0.95,0.07,1.8,0.62,2.25,1.44 l14.35,24.26c2.1,2.72,2.36,5.42,1.21,8.12c-0.95,2.21-2.87,4.25-5.49,6.15c-0.77,0.66-1.69,1.33-2.66,2.03 c-3.21,2.33-6.86,5.02-5.61,8.18L33.84,50.25L33.84,50.25L33.84,50.25z"/></g></svg>',
    }, 'phone', title)

    const locNd = this.renderLink('locate-btn', !!avail.store.gmapUrl, {
      href: avail.store.gmapUrl,
      classes: ['btn', 'locate'],
      labelKey: 'AWE-2STEP-PAGE.LOCATE',
      innerHTML: '<svg id="location-icon" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.1 14.8"><g id="Groupe_1259" data-name="Groupe 1259"><g id="Groupe_1223" data-name="Groupe 1223"><g id="Groupe_1201" data-name="Groupe 1201"><path id="Icon_awesome-map-marker-alt" data-name="Icon awesome-map-marker-alt" d="M7.69,15c-4.2-6.09-5-6.71-5-8.95a5.55,5.55,0,0,1,11.1,0c0,2.24-.78,2.86-5,9a.7.7,0,0,1-1,.18A.77.77,0,0,1,7.69,15Zm.57-6.64A2.32,2.32,0,1,0,6,6.07,2.32,2.32,0,0,0,8.26,8.38Z" transform="translate(-2.71 -0.52)"/></g></g></g></svg>',
    }, 'map', phoneNd || whatsappNd || appointmentNd || title)

    this.renderLink('buy-btn', !!(avail.clkUrl && avail.voucher.optional), {
      href: avail.clkUrl,
      classes: ['btn', 'buy'],
      labelKey: 'BUY',
      innerHTML: '<svg id="buy-icon" width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.44 14.81"><path d="M7.21 13.48a1.39 1.39 0 1 1-1.39-1.39 1.39 1.39 0 0 1 1.39 1.39zM14.18 13.48a1.39 1.39 0 1 1-1.39-1.39 1.38 1.38 0 0 1 1.39 1.39zM6.22 11a2 2 0 0 1-2-1.62L3.19 4.1v-.08l-.52-2.54H.75a.75.75 0 0 1 0-1.5h2.54a.75.75 0 0 1 .73.6l.52 2.56h10.15a.72.72 0 0 1 .58.28.73.73 0 0 1 .16.62l-.97 5.33a2 2 0 0 1-2 1.63H6.22zM4.84 4.66l.88 4.42a.54.54 0 0 0 .52.42h6.22a.52.52 0 0 0 .53-.41l.85-4.43z"/></svg>',
    }, 'url', locNd || phoneNd || whatsappNd || appointmentNd || title)

    this.dispatchEvent(new CustomEvent('loader-start', { bubbles: true, detail: { target: 'loader-form', auto: false } }))
  }

}

customElements.define('awe-2step-page', Awe2StepPage)
